module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	
	fox.registerWidget('VerifiedCall', {

		configure: function () {
			this.trefs = {
				page: {
					template: 'callme_widget_full',
					wStyle: 'i',
					width: 272,
					height: 265
				},
				banner: {
					template: 'callme_widget_banner',
					wStyle: 'j',
					width: 189,
					height: 41
				}
			};

			this.registerOptions('', {
				widgets: {
					verifiedCall: {
						widget: 'Widget',
						'hooks.onStopRendering': this.onStopRendering
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.verifiedCallProfile = fox.getEnv('modelProps.verifyProfile');

			this.registerOptions('.Widget', {
				autoRender: true,
				embed: this.getOption('embed'),
				template: this.trefs[this.getOption('style') || 'page'].template,
				templateOptions: {
					vfcProfile: this.verifiedCallProfile
				}
			});
		
			this.callParent('init', arguments);
		},

		getIframeWidget: function () {
			var
				style = this.trefs[this.getOption('style')];

			if (this.iframe === undefined) {
				this.iframe = $('<iframe>').attr({
					src: ['https://verifiedcall.com/module/?talent=', this.verifiedCallProfile, '&style=', style.wStyle, '&aff=modelcentro'].join(''),
					frameborder: '0',
					scrolling: 'no',
					width: style.width,
					height: style.height,
					allowTransparency: true,
					aff: 'modelcentro'
				});
			}

			return this.iframe;
		},

		onStopRendering: function () {
			var
				$iframe = this.getParent().getIframeWidget();

			$iframe.prependTo(this.fragment);
		}

	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/verifiedcall.js
// module id = 921
// module chunks = 4